export default function ShopPage() {
  return <h1>Shop Our Products</h1>
}
